<section class="typ-sync-card" data-testid="type-sync-card">
  <header class="typ-sync-card__head">
    <span class="typ-sync-card__icon" aria-hidden="true">
      <svg
        width="17"
        height="17"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="3"></circle>
        <path
          d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h0a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h0a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
        ></path>
      </svg>
    </span>
    <div class="typ-sync-card__intro">
      <h3 class="typ-sync-card__title">{{ 'requirements.typeSync.title' | translate }}</h3>
      <p class="typ-sync-card__desc" [innerHTML]="'requirements.typeSync.description' | translate"></p>
      <span class="typ-sync-card__auto-pill">
        <span class="typ-sync-card__auto-dot" aria-hidden="true"></span>
        {{ 'requirements.typeSync.autoPill' | translate }}
      </span>
    </div>
  </header>

  <div class="typ-sync-card__list">
    @if (!hasHosts()) {
      <div class="typ-sync-card__empty" data-testid="type-sync-empty">
        {{ 'requirements.typeSync.empty' | translate }}
      </div>
    }

    @for (row of hosts(); track row.host) {
      <article class="typ-sync-card__host" [class.typ-sync-card__host--active]="row.isSynced">
        <div class="typ-sync-card__host-row">
          <span class="typ-sync-card__chip" [style.background]="row.color">{{ row.providerLabel }}</span>
          <code class="typ-sync-card__host-name">{{ row.host }}</code>
          <span class="typ-sync-card__spacer"></span>

          @if (row.isSynced) {
            <span class="typ-sync-card__count">
              <svg
                width="10"
                height="10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              @if (row.syncedTypes.length === 1) {
                {{ 'requirements.typeSync.countTakenOne' | translate }}
              } @else {
                {{ 'requirements.typeSync.countTaken' | translate: { count: row.syncedTypes.length } }}
              }
            </span>
            <button
              type="button"
              class="typ-sync-card__icon-btn"
              [attr.data-testid]="'type-sync-remove-' + row.host"
              [attr.aria-label]="'requirements.typeSync.remove' | translate"
              [attr.aria-busy]="isBusy(row.host)"
              [title]="'requirements.typeSync.remove' | translate"
              [disabled]="isBusy(row.host)"
              (click)="removeHost(row)"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          } @else {
            <button
              type="button"
              class="typ-sync-card__fetch-btn"
              [attr.data-testid]="'type-sync-fetch-' + row.host"
              [attr.aria-busy]="isBusy(row.host)"
              [disabled]="isBusy(row.host)"
              (click)="syncHost(row)"
            >
              {{ (isBusy(row.host) ? 'requirements.typeSync.loading' : 'requirements.typeSync.fetch') | translate }}
            </button>
          }
        </div>

        @if (row.isSynced) {
          <div class="typ-sync-card__chips">
            @for (name of row.syncedTypes; track name) {
              <span class="typ-sync-card__type-chip" data-testid="type-sync-chip">
                <span class="typ-sync-card__type-dot" [style.background]="row.color" aria-hidden="true"></span>
                {{ name }}
              </span>
            }
          </div>
        }
      </article>
    }
  </div>

  <footer class="typ-sync-card__notice">
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
    <span>{{ 'requirements.typeSync.footerNotice' | translate }}</span>
  </footer>
</section>
